import Svgicon from '@/components/svgicon.vue'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('Svgicon', Svgicon)
})
